<template>
  <div>
    <el-row>
      <div class="main-body--content margin-bottom-1rem">
        <c-block-box
          title="年度营收(万元)"
          style="height: 11.75rem"
          class="margin-right-1rem top-item1"
        >
          <AnnualRevenue :option="dig.annualTarget"></AnnualRevenue>
        </c-block-box>
        <c-block-box
          title="月总体营收（万元）"
          class="margin-right-1rem top-item"
          style="height: 11.75rem"
        >
          <div class="total-revenue">
            <div class="left">
              <div class="revenue-box">
                <div class="number">{{ numberSplitWithComma(dig.nowIncome || 0) }}</div>
                <div class="tendency">
                  <div class="tendency-text">
                    <span>环比</span>
                    <img :src="upsAndDowns(dig.monthRatio || 0)" />
                    <em>{{ percentage(dig.monthRatio || 0) }}%</em>
                  </div>
                </div>
                <div class="target">
                  <c-target-rate
                    label="预计总营收"
                    :target="`${numberSplitWithComma(dig.expectedTotalIncome)}`"
                    :is-progress="false"
                  ></c-target-rate>
                  <c-target-rate
                    label="待执行"
                    :target="`${numberSplitWithComma(dig.futureIncome)}`"
                    :is-progress="false"
                  ></c-target-rate>
                  <c-target-rate
                    label="额外商机"
                    :target="`${numberSplitWithComma(dig.proposedOrderData)}`"
                    :is-progress="false"
                  ></c-target-rate>
                  <div class="tendency-text">
                    <span>目标 {{ numberSplitWithComma(dig.monthTarget) }}</span>
                    <span class="line">|</span>
                    <span>完成 {{ percentage(dig.monthFinishRatio || 0) }}%</span>
                  </div>
                  <!-- <c-target-rate
                    label="目标"
                    :target="`${dig.monthTarget}`"
                    :is-progress="false"
                  ></c-target-rate>
                  <c-target-rate
                    label="完成率"
                    :num="percentage(dig.monthFinishRatio || 0)"
                  ></c-target-rate> -->
                  <!-- <c-target-rate
                    label="匹配度"
                    :num="percentage(dig.targetFinishRatio || 0)"
                  ></c-target-rate> -->
                </div>
              </div>
            </div>
            <div class="right">
              <ChartBarLine
                id="revenue-line"
                width="100%"
                height="9.25rem"
                :option="revenueLine"
                v-if="businessLine.xData.length"
              ></ChartBarLine>
            </div>
          </div>
        </c-block-box>
        <div class="right-bottom-end-box top-flex-grid3 margin-right-1rem">
          <c-block-box
            title="开机广告城市销售率"
            class="unit-header--padding-1rem little-half-item-box"
          >
            <div class="content-wrap content-wrap-825">
              <div class="item" v-for="(item,index) in dig.deliveryChannel" :key="index">
                <div class="label-wrap">
                  <span class="name">{{ item.cityName }}</span>
                  <span class="kc">库存：{{ numberSplitWithComma(item.stock) }}cpm</span>
                  <!-- <span class="percent">{{ item.sellRate }}%</span> -->
                </div>
                <CcProgress :color="CcProgressColor[index]" :num="+(item.sellRate*100).toFixed(2)" :show-progress-count="true"></CcProgress>
              </div>
            </div>
          </c-block-box>
          <c-block-box
            title="媒体曝光比例"
            class="unit-header--padding-1rem little-half-item-box"
          >
            <div class="pro-contri-wrap">
              <!-- <ProportionAgentContribution :data="dig.contributionProportion" :series-type="testSeriType"></ProportionAgentContribution> -->
              <DomeEchartWrap ref="contributionProportion" id="contributionProportion"></DomeEchartWrap>
            </div>
          </c-block-box>
        </div>
        <c-block-box
          title="月广告均价"
          style="height: 11.75rem"
        >
          <div class="total-revenue" style="width:10rem;">
            <div class="left">
              <div class="revenue-box">
                <div class="number-name">开机</div>
                <div class="number">{{ numberSplitWithComma(dig.todayOpenPrice || 0) }}</div>
                <div class="number-name" style="padding-top: .8rem">前贴</div>
                <div class="number">{{ numberSplitWithComma(dig.todayPrePrice || 0) }}</div>
              </div>
            </div>
          </div>
        </c-block-box>
      </div>
      <div class="digital-box2">
        <el-row>
          <el-col :span="10" style="padding-right:.5rem">
            <c-block-box
              title="代理完成情况（万元）"
              class="margin-bottom-1rem unit-box--custom unit-header--padding-1rem"
              :icon="true"
            >
              <div
                slot="sub-title"
                id="closePic"
                class="digital-btn coocaa_btn"
                leftTarget="#closePic"
                upTarget="#DigitalMarketing"
                router="/kanban-config-view?id=51"
                rel="digitalDetails"
                @click="seeDetails('/kanban-config-view?id=51')"
              >
                详情
              </div>
              <div class="table-body">
                <table
                  class="table-item"
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                >
                  <thead class="table-head">
                    <tr>
                      <th class="head-item">代理商</th>
                      <!-- <th class="head-item">负责人</th> -->
                      <th class="head-item">月预估</th>
                      <th class="head-item">月完成</th>
                      <th class="head-item">月完成率</th>
                      <th class="head-item">年完成</th>
                      <th class="head-item">年总框</th>
                      <th class="head-item">完成率</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <div class="vacancy"></div>
                    <!-- dig.contributionData -->
                    <tr
                      class="table-line"
                      v-for="(item, index) in dig.contributionData"
                      :key="index"
                      :class="[
                        index === 0?'tr-total':''
                      ]"
                    >
                      <!-- <template v-if="index ===0">
                        <td class="body-lable" colspan="2">{{ item.dictLabel.split("-")[0] }} </td>
                        <td class="body-lable" v-else>{{ item.dictLabel.split("-")[0] }}</td>
                      </template>
                      <template v-else>
                        <td class="body-lable">{{ item.dictLabel.split("-")[0] }} </td>
                        <td class="body-lable">{{ item.dictLabel.split("-")[1] }} </td>
                      </template> -->
                      <td class="body-lable">{{ item.dictLabel.split("-")[0] }}</td>
                      <td class="body-lable">{{ numberSplitWithComma(item.indicatorValueD/10000) }} </td>
                      <td class="body-lable">{{ numberSplitWithComma(item.indicatorValueE/10000) }} </td>
                      <td class="body-lable">{{ (item.monthRate*100).toFixed(2) }} %</td>
                      <td class="body-lable">{{ numberSplitWithComma(item.indicatorValueB/10000) }} </td>
                      <td class="body-lable">{{ numberSplitWithComma(item.indicatorValueA/10000) }} </td>
                      <td class="body-lable">{{ (item.annualRate *100).toFixed(2) }} %</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </c-block-box>
            <div class="">
              <c-block-box
                title="核心代理商投放情况"
              >
                <div class="hexin-wrap">
                  <DomeEchartWrap ref="StackedColumn" id="StackedColumn"></DomeEchartWrap>
                </div>
              </c-block-box>
              <!-- <c-block-box
                title="代理商贡献占比"
                class="unit-header--padding-1rem little-half-item-box"
              >
                <div class="pro-contri-wrap">
                  <ProportionAgentContribution :data="dig.contributionProportion"></ProportionAgentContribution>
                </div>
              </c-block-box> -->
            </div>
          </el-col>
          <el-col :span="14" class="right" style="padding-left:.5rem">
            <el-col :span="24" style="margin-bottom:1rem">
              <el-col :span="8" class="right-lists-pro-item-wrap">
                <c-block-box
                  title="核心代理商业绩贡献度（元）"
                  class="unit-header--padding-1rem little-half-item-box"
                >
                  <div class="pro-contri-wrap-10">
                    <!-- <ProportionAgentContribution id="ProportionAgentContributionA" :data="dig.contributionProportion">
                    </ProportionAgentContribution> -->
                    <DomeEchartWrap ref="customerContribution" id="customerContribution"></DomeEchartWrap>
                  </div>
                </c-block-box>
              </el-col>
              <el-col :span="8" class="right-lists-pro-item-wrap">
                <c-block-box
                  title="品牌业绩贡献度（元）"
                  class="unit-header--padding-1rem little-half-item-box"
                >
                  <div class="pro-contri-wrap-10">
                    <!-- <ProportionAgentContribution id="ProportionAgentContributionB" :data="dig.contributionProportion"></ProportionAgentContribution> -->
                    <DomeEchartWrap ref="brandContribution" id="brandContribution"></DomeEchartWrap>
                  </div>
                </c-block-box>
              </el-col>
              <el-col :span="8" class="right-lists-pro-item-wrap">
                <c-block-box
                  title="行业业绩贡献度（元）"
                  class="unit-header--padding-1rem little-half-item-box"
                >
                  <div class="pro-contri-wrap-10">
                    <!-- <ProportionAgentContribution id="ProportionAgentContributionC" :data="dig.contributionProportion"></ProportionAgentContribution> -->
                    <DomeEchartWrap ref="tradeContribution" id="tradeContribution"></DomeEchartWrap>
                  </div>
                </c-block-box>
              </el-col>
            </el-col>
            <el-col :span="24">
              <c-block-box
                title="近3月项目支撑情况"
                class="unit-header--padding-1rem"
                :icon="true"
              >
                <div class="business-tags" slot="sub-title">
                  <span>启动阶段</span>
                  <span class="span1">实施阶段</span>
                  <span class="span2">收尾阶段</span>
                </div>
                <div style="">
                  <project-list :project="projectLIst" height="18rem">
                    <!-- <template v-slot="slotProps">
                      <div class="line">
                        <span class="lable">项目名称：</span>
                        <span class="value">{{ slotProps.data.name }}</span>
                        <span class="tags"><i class="icon"></i>{{ slotProps.data.projectCurrent }}</span>
                      </div>
                      <div class="line">
                        <span class="lable">负责人：</span>
                        <span class="value">{{ slotProps.data.projectValue }}</span>
                      </div>
                      <div class="flex-wrap-row">
                        <div class="line">
                          <span class="lable">目标：</span>
                          <span class="value">{{ slotProps.data.projectValue }}</span>
                        </div>
                        <div class="line">
                          <span class="lable">成果：</span>
                          <span class="value">{{ slotProps.data.manualWork }}</span>
                        </div>
                      </div>
                    </template> -->
                  </project-list>
                </div>
              </c-block-box>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import ChartBarLine from '@/components/echarts/line1'
import ChartPie from '@/components/echarts/pie'
import ProjectList from '../components/ProjectList'
import AnnualRevenue from '@/components/DigitalMarketing/AnnualRevenue'
import ProportionAgentContribution from '@/components/DigitalMarketing/ProportionAgentContribution'
import StackedColumn from '@/components/DigitalMarketing/StackedColumn'
import CcProgress from '@/components/DigitalMarketing/CcProgress'
import { StackingAgentEchartOp } from './js/index'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import { contributionProportionEchartOp, customerContributionEchartOp, brandContributionEchartOp, tradeContributionEchartOp } from './js/DigitalMarketing-3.4.js'
export default {
  mixins: [common],
  components: {
    DomeEchartWrap,
    ChartBarLine,
    // ChartPie,
    ProjectList,
    AnnualRevenue,
    CcProgress,
    ProportionAgentContribution
  },
  props: {},
  data () {
    return {
      testSeriType: { radius: ['0%', '65%'], center: ['35%', '50%'] },
      CcProgressColor: ['#017cfb', '#1ee4dc', '#ffd71c'],
      directAgent: {
        config: {
          type: 2,
          picRadius: '80%',
          picCenter: ['30%', '50%'],
          tooltip: {
            show: true
          },
          legend: {
            right: 20,
            y: 'center'
          }
        },
        data: []
      },
      direct: {
        config: {
          type: 2,
          picRadius: '80%',
          picCenter: ['30%', '50%'],
          tooltip: {
            show: true
          },
          legend: {
            right: 20,
            y: 'center'
          }
        },
        data: []
      },
      projectLIst: [],
      dig: {
        monthRecord: {},
        dayRecord: {},
        projectRateCPM: {},
        contributionProportion: {}, // 代理商贡献占比
        deliveryChannel: []
      },
      timeData: {
        data: {
          up: {},
          cur: {},
          down: {}
        }
      },
      revenueLine: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        boundaryGap: false,
        xData: [],
        series: []
      },
      businessLine: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        boundaryGap: false,
        color: ['#FF5A18', '#FFD71A', '#1895FF', '#1EE4DC'],
        xData: [],
        series: []
      },
      businessLine2: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        boundaryGap: false,
        xData: [],
        series: []
      }
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {
    lineFormatData (data, type) {
      const isAndroid = this.isAndroid
      const keys = Object.keys(data)
      let minValueArr = []
      keys.forEach((item) => {
        minValueArr.push(this.mathMin(data[item].data || []))
      })
      const minValue = this.mathMin(minValueArr)
      const lineData = {
        min: minValue,
        xData: data[keys[0]].date.map(item => {
          return this.$cUtils.format.formatDate(item, 'MM-dd')
        }),
        series: keys.map(item => {
          const itemData = {
            name: item,
            data: data[item].data,
            symbol: 'none',
            type: 'line',
            lineStyle: {
              type: item === '目标' ? 'dashed' : 'solid',
              width: isAndroid ? 0.5 : 2
            }
          }
          if (type && item !== '目标') {
            this.$set(itemData, 'areaStyle', {})
            this.$set(itemData, 'stack', '总量')
          }
          return itemData
        })
      }
      return lineData
    }
  },
  created () {},
  activated () {
    const yearMonth = JSON.parse(sessionStorage.getItem('toggleDate')).time
    this.$service.fetch({
      url: 'api/digitalMarketing/dashboard/v2?month=' + yearMonth
    }).then(res => {
      this.dig = res
      const isAndroid = this.isAndroid
      this.projectLIst = res.projects
      this.dig.deliveryChannel = this.dig.deliveryChannel.map(item => {
        if (isNaN(item.sellRate)) {
          item.sellRate = 0
        }
        item.sellRate = +item.sellRate.toFixed(2)
        return item
      })
      this.revenueLine = Object.assign(this.revenueLine, this.lineFormatData(res.dayIncome, 1), {
        legend: {
          top: !isAndroid ? 10 : 20
        }
      })
      this.businessLine = Object.assign(this.businessLine, this.lineFormatData(res.projectRateCPM.projectPic), {
        legend: {
          top: !isAndroid ? 10 : 20
        }
      })
      this.businessLine2 = Object.assign(this.businessLine2, this.lineFormatData(res.price), {
        legend: {
          top: !isAndroid ? 10 : 20
        }
      })
      const directAgent = res.directAgent ?? {}
      this.directAgent.data = Object.keys(directAgent).map(item => {
        return {
          name: item,
          value: directAgent[item]
        }
      })
      const direct = res.direct ?? {}
      this.direct.data = Object.keys(direct).map(item => {
        return {
          name: item,
          value: direct[item]
        }
      })
      this.$nextTick(() => {
        this.$refs['contributionProportion'].setEchartOption(contributionProportionEchartOp({ v: this, data: res.exposureVOList }))
        this.$refs['customerContribution'].setEchartOption(customerContributionEchartOp({ v: this, data: res.customerContribution }))
        this.$refs['brandContribution'].setEchartOption(brandContributionEchartOp({ v: this, data: res.brandContribution }))
        this.$refs['tradeContribution'].setEchartOption(tradeContributionEchartOp({ v: this, data: res.tradeContribution }))
        this.$parent.bindKey(this.$route.name)
        this.$refs['StackedColumn'].setEchartOption(StackingAgentEchartOp({ v: this, data: res.coreCustomerMap }))
      })
    })
  }
}
</script>

<style lang="stylus" scoped>
@import '../stylus/DigitalMarketing.styl'

.pro-contri-wrap
  height 9.25rem
.top-flex-grid3
  flex-grow 1
.pro-contri-wrap-10
  height 10rem
.content-wrap-825
  height 8.4rem
.flex-wrap-row
  display flex
.digital-box2 .left
  flex-shrink 0
  width auto
.digital-box2 .right
  padding-left: 0
.main-body--content .top-item
  width 24.7rem

.right-lists-pro-item-wrap
  &:first-child
    padding-left 0 !important
  &:last-child
    padding-right 0 !important
  &+&
    padding-left 1rem
  .little-half-item-box
    &:first-child
      padding-left 0
    &:last-child
      padding-right 0

.hexin-wrap
  height 14.8rem

.label-wrap
  color : rgba(255, 255, 255, .8)

.table-item
 .table-body
  .table-line.tr-total
    td
      background-color: #1864ff70

.line
  margin 0 .3rem
</style>
